// extracted by mini-css-extract-plugin
module.exports = {"container":"e_bA","icon":"e_cA"};